import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import { FormattedMessage } from "react-intl";

function PasswordResetAppRedirect() {
  const appLink = "com.aplby.learnware://";

  useEffect(() => {
    window.location.replace(appLink);
  }, []);

  return (
    <div className="form">
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card
                  className="text-white bg-primary py-5 d-md-down-none"
                  style={{ width: 44 + "%" }}
                >
                  <CardBody className="text-center">
                    <div>
                      <img
                        style={{ width: 100 + "%" }}
                        src={"img/LearnWareLoggo.png"}
                        className="img-avatar"
                        alt="LearnWARE logga in"
                      />
                    </div>
                  </CardBody>
                </Card>
                <img
                  src={"img/m_logo.png"}
                  style={{
                    maxWidth: "92%",
                    position: "absolute",
                    top: "-190px",
                    marginLeft: "5px",
                  }}
                  alt="Signin logo"
                  className="d-lg-none img-responsive"
                />
                <Card className="p-4">
                  <CardBody>
                    <h1>
                      <FormattedMessage id="ContinueInApp" />
                    </h1>
                    <p className="text-muted">
                      <FormattedMessage id="YouCanNowSignInToAppWithNewPassword" />
                    </p>
                    <Button
                      outline
                      color="primary"
                      onClick={() => window.location.replace(appLink)}
                    >
                      <FormattedMessage id="GoToApp" />
                    </Button>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default PasswordResetAppRedirect;
